import {action, query} from "@solidjs/router";
import {CreateCheckout} from "@gs-yoga/sdk/types";
import sdk from "~/sdk/sdk";
import {ApiError} from "~/sdk/error";


export const getCheckout = query(async (id) => {
    try {
        return await sdk().checkout.get(id).json()
    } catch (e) {
        throw new ApiError("Failed to get checkout", e)
    }
}, "getCheckout")

export const createCheckout = action(async (create: CreateCheckout) => {
    try {
        return await sdk().checkout.create(create).json()
    } catch (e) {
        throw new ApiError("Failed to create checkout", e)
    }
})